export default __webpack_public_path__ + "static/media/icon-analytics.bdf99396.svg";